import { render, staticRenderFns } from "./Zonas.vue?vue&type=template&id=08816d5e&"
import script from "./Zonas.vue?vue&type=script&lang=js&"
export * from "./Zonas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports